import { Route } from 'react-router-dom'

/**
 * Public Route component. Simple `<Route />` wrapper to indicate it can be accessed
 * by anyone.
 */

export default Route
